import Restaurantform from "../../../components/Resturent_form";
import { useState } from "react";
import { SuccessNotify } from "../../../constants/tostify";
import { FailedNotify } from "../../../constants/tostify";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import url from "../../../config/axios";
import { publishImage } from "../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { decodeId } from "../../../utils/idObfuscator";
import { useGetShopByIdQuery } from "../../../features/shop/shopApiSlice";

const ResturentPostform = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [isloading, setIsloading] = useState();
  const [displayimg, setDisplayimg] = useState();
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const cleanShopId = decodeId(id) || id || "";
  const { data: shopRes } = useGetShopByIdQuery(cleanShopId, {
    skip: !cleanShopId,
  });
  const shop = shopRes?.data?.Shop;

  const [data, setData] = useState({
    categoryid: "",
    subCategoryid: ""
  });

  const Handledata = (e) => {
    const raw = e.target.value || "";
    const dot = raw.indexOf(".");
    let idPart = raw;
    let namePart = "";
    if (dot !== -1) {
      idPart = raw.slice(0, dot);
      namePart = raw.slice(dot + 1);
    }
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: [idPart, namePart],
    }));
  };

  const categoryName = data?.categoryid?.[1] || "";
  const categoryid = data?.categoryid?.[0] || "";
  const subcategoryName = data?.subCategoryid?.[1] || "";
  const subcategoryid = data?.subCategoryid?.[0] || "";

  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });
      setFooddata((fooddata) => ({
        ...fooddata,
        images: abc
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [fooddata, setFooddata] = useState({
    businessType: "foodShopItem",
    userid: "",
    shopid: "",
    dishname: "",
    category: "",
    categoryid: "",
    subCategoryid: "",
    price: "",
    preparationTime: "",
    country: "",
    city: "",
    state: "",
    subCategory: "",
    contact: "",
    email: "",
    salesPromotion: "",
    specialOffers: "",
    currency: "",
    duration: "",
    images: [""],
    status: true,
  });

  useEffect(() => {
    setFooddata((fooddata) => ({
      ...fooddata,
      category: categoryName,
      categoryid: categoryid,
      subCategory: subcategoryName,
      subCategoryid: subcategoryid
    }));
  }, [categoryid, categoryName, subcategoryName, subcategoryid]);

  useEffect(() => {
    url
      .get("/category/type/?type=foodShop&parentCategory=")
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategory(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error);
      });
  }, []);

  const Mydata = () => {
    url
      .get(
        `/category/type/?type=foodShopItem&parentCategory=${categoryName}`
      )
      .then(async (response) => {
        if (response?.data?.success) {
          setShopCategorytwo(response?.data?.data?.Category);
        }
      })
      .catch((error) => {
        console.log("servicesCategories", error);
      });
  };

  const userDatahandler = (e) => {
    setIsloading(true);
    e.preventDefault();
    const payload = {
      ...fooddata,
      userid: fooddata.userid || shop?.userid?._id || shop?.userid || name?._id,
      shopid: fooddata.shopid || shop?._id || cleanShopId || id,
      country: fooddata.country,
      state: fooddata.state,
      city: fooddata.city,
      businessType: "foodShopItem",
    };
    url
      .post("fooditem/", payload)
      .then(async (response) => {
        if (response?.data?.success) {
          setIsloading(false);
          setTimeout(() => {
            SuccessNotify("Add Post Successfully");
          }, 1000);
          navigate(`/RestaurantAlldata/${id}`);
        }
      })
      .catch((e) => {
        setIsloading(false);
        FailedNotify("Failed To Post Try Again!");
      });
  };

  useEffect(() => {
    const resolvedUserId = shop?.userid?._id || shop?.userid || name?._id || "";
    const resolvedShopId = shop?._id || cleanShopId || id || "";
    if (!resolvedUserId && !resolvedShopId) return;

    const defaultCountry =
      shop?.resolvedCountry ||
      shop?.country ||
      shop?.userid?.address?.country ||
      shop?.userid?.country ||
      name?.address?.country ||
      name?.country ||
      "";
    const defaultState =
      shop?.resolvedRegion ||
      shop?.state ||
      shop?.userid?.address?.state ||
      shop?.userid?.state ||
      name?.address?.state ||
      name?.state ||
      "";
    const defaultCity =
      shop?.resolvedCity ||
      shop?.city ||
      shop?.userid?.address?.city ||
      shop?.userid?.city ||
      name?.address?.city ||
      name?.city ||
      name?.MCity ||
      "";

    setFooddata((prev) => ({
      ...prev,
      userid: resolvedUserId || prev.userid,
      shopid: resolvedShopId || prev.shopid,
      country: prev.country || defaultCountry,
      state: prev.state || defaultState,
      city: prev.city || defaultCity,
    }));
  }, [shop, name, cleanShopId, id]);

  if (isloading) {
    return <Loader heightsetting="screenHeight" />;
  }

  const handlevalue = (e) => {
    setFooddata((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <>
      <Restaurantform
        btntext="Post"
        handlevalue={handlevalue}
        Handledata={Handledata}
        Mydata={Mydata}
        userDatahandler={userDatahandler}
        shopCategory={shopCategory}
        shopCategorytwo={shopCategorytwo}
        id={id}
        getInputProps={getInputProps}
        getRootProps={getRootProps}
        displayimg={displayimg}
        setDisplayimg={setDisplayimg}
        isUploading={isUploading}           
        uploadProgress={uploadProgress} 
        fooddata={fooddata}
        setFooddata={setFooddata}
      />
    </>
  );
};

export default ResturentPostform;
